import { render, staticRenderFns } from "./submitList.vue?vue&type=template&id=5f9b6158"
import script from "./submitList.vue?vue&type=script&lang=js"
export * from "./submitList.vue?vue&type=script&lang=js"
import style0 from "./submitList.vue?vue&type=style&index=0&id=5f9b6158&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports